/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type {
  FacadeHeroCustomDataLogic,
  FacadeHeroCustomDataLogicInterface,
} from "../FacadeHeroCustomDataLogic";

const _abi = [
  {
    inputs: [],
    name: "DEATH_COUNT_HASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "HERO_CLASS_HASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "KARMA_HASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "heroBiome",
        type: "uint8",
      },
    ],
    name: "_getBossCompletedIndex",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "objectId",
        type: "uint32",
      },
    ],
    name: "_getMonsterCounterIndex",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "storyId",
        type: "uint16",
      },
    ],
    name: "_getStoryIndex",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
] as const;

export class FacadeHeroCustomDataLogic__factory {
  static readonly abi = _abi;
  static createInterface(): FacadeHeroCustomDataLogicInterface {
    return new Interface(_abi) as FacadeHeroCustomDataLogicInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): FacadeHeroCustomDataLogic {
    return new Contract(
      address,
      _abi,
      runner
    ) as unknown as FacadeHeroCustomDataLogic;
  }
}
